import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SurveyQuestionAnswerService, SurveyService } from '../../openapi';
import {
  loadCollection, loadCollectionFailure,
  loadCollectionSuccess,
  sendAnswer,
  sendAnswerFailure,
  sendAnswerSuccess
} from '../actions/surveys.actions';
import { forkJoin, map, of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class SurveysEffects {
  constructor(
    private actions$: Actions,
    private surveyService: SurveyService,
    private surveyQuestionAnswerService: SurveyQuestionAnswerService
  ) {
  }

  sendAnswer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(sendAnswer),
      switchMap((action) =>
        forkJoin([
          ...action.items.map(surveyQuestionAnswer =>
            this.surveyQuestionAnswerService.apiSurveyQuestionAnswersPostCollectionSurveyQuestionAnswerCollection({
              surveyQuestionAnswer
            })
          )
        ]).pipe(
          map(() => {
            action.successFunc();
            return sendAnswerSuccess();
          }),
          catchError(() => {
            return of(sendAnswerFailure());
          })
        )
      )
    )
  );

  loadCollection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCollection),
      switchMap(() => {
          return this.surveyService.apiSurveysGetCollectionSurveyCollection({
            pagination: false,
            typeCode: 'survey'
          }).pipe(
            map(collection => loadCollectionSuccess({ collection })),
            catchError(() => of(loadCollectionFailure()))
          );
        }
      )
    )
  );
}
